import { Model } from "@/models/base/model";
import { validationCommon, ValidationResult } from "@/utils/validation-common";
import { _$t } from "@/utils/i18n";

export class Password extends Model {
  // プロパティは名前: 型
  name: string;
  url: string;

  // コストラクタ（省略可能）
  constructor(params: any = {}) {
    super(params);
    this.name = "Password";
    this.url = "";

    this.validation = this.getValidationSchema();
    this.labels = this.getValidationLabels();
  }

  // パスワード更新
  async updateData(params: any = {}) {
    this.url = "/cms/api/profile/changepassword";
    return await this.save(params, "PUT");
  }

  // 独自のバリデーション処理
  validate_addon(): ValidationResult {
    // チェックしたい項目、チェック処理をこちらに記載していく
    const errors = [];
    // 独自チェックを持つ項目リスト作成
    const list = validationCommon.getAddonList(this.validation);

    // 各項目でチェック処理を行う
    for (const obj of list) {
      // noHalfSpace
      if (obj.value.addOn.noHalfSpace !== undefined) {
        const noHalfSpace_error = validationCommon.addOnFunc.noHalfSpace(
          this.attributes[obj.key],
          obj.key,
          obj.value.addOn.noHalfSpace,
          this
        );
        if (noHalfSpace_error) {
          errors.push(noHalfSpace_error);
        }
      }
    }

    const valid = errors.length ? false : true;
    // 返却情報の作成
    return validationCommon.createResult(valid, errors);
  }

  // バリデーションのルールを定義
  getValidationSchema() {
    return {
      password: {
        type: "string",
        required: true,
        pattern: "alphanumchar",
        addOn: {
          noHalfSpace: true, // 半角スペース不可
        },
        minLength: 8,
        maxLength: 50,
      },
    };
  }

  // バリデーションエラー時のラベルを定義
  getValidationLabels() {
    return {
      password: _$t("changePassword_text_newPassword"),
    };
  }
}
